import { render, staticRenderFns } from "./changyGj.vue?vue&type=template&id=4ba9a9a6&scoped=true"
import script from "./changyGj.vue?vue&type=script&lang=js"
export * from "./changyGj.vue?vue&type=script&lang=js"
import style0 from "./changyGj.vue?vue&type=style&index=0&id=4ba9a9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9a9a6",
  null
  
)

export default component.exports